import React, {useState, useEffect, useRef} from 'react';


const Main = ({currentUserId}) => {

  const [media, setMedia] = useState([]);
  const [translateX, setTranslateX] = useState(0);
  const carouselRef = useRef(null);

  useEffect(() => {
    $.ajax({
      type: 'GET',
      url: '/featured_multimedia',
      dataType: 'json',
      success: function(res) {
        setMedia(res);
      }
    })
  }, [])

  // The number 300 needs to be updated if width of these classes change in the css
  // .attachment-container, .image-container, .image 
  const slideWidth = 300 + 16 
  const containerWidth = carouselRef.current?.clientWidth || 0
  const totalContentWidth = media.length * slideWidth
  const maxTranslateX = containerWidth - totalContentWidth

  const canSlideLeft  = translateX < 0
  const canSlideRight = translateX > maxTranslateX

  const handleArrowClick = direction => {
    let newX = translateX
    if (direction === 'left' && canSlideLeft) {
      newX = Math.min(translateX + slideWidth, 0)
    }
    if (direction === 'right' && canSlideRight) {
      newX = Math.max(translateX - slideWidth, maxTranslateX)
    }
    setTranslateX(newX)
    fireAmplitude('multimediaClicked', {type: direction === 'left' ? 'left-arrow' : 'right-arrow'})
  }

  const fireAmplitude = (eventType, data) => {
    $.ajax("/amplitudes", {
      dataType: "json",
      type: "POST",
      data: { 
              event_type: eventType,
              user_id: currentUserId,
              ...data
            }
    })
  }

  const renderMedias = () => {
    return media.map((medium, idx) => {
      return (
        <div
          key={idx}
          className="attachment-container"
          onClick={()=>{fireAmplitude('multimediaClicked', {type: 'video', url: medium.url})
        }}>
          <a href={medium.url} target="_blank">
            <div className='image-container'>
                <img className='image' src={medium.image.url}/>
            </div>
            <h6>{medium.name}</h6>
          </a>
        </div>
      )
    })
  }

  const renderButtons = () => {
    return (
      <div className='btn-background-container'>
        <div className="btn-container" onClick={() => handleArrowClick('left')}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M21 11.9999H3M3 11.9999L10 5M3 11.9999L10 18.9999"
              stroke={canSlideLeft ? "black" : "#D6D9DC"}
              strokeWidth="1.5"
              strokeLinecap="square"/>
          </svg>
        </div>
        <div className="btn-container" onClick={() => handleArrowClick('right')}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none">
            <path
              d="M3 11.9999H21M21 11.9999L14 5M21 11.9999L14 18.9999"
              stroke={canSlideRight ? "black" : "#D6D9DC"}
              strokeWidth="1.5"
              strokeLinecap="square"/>
          </svg>
        </div>
      </div>
    )
  }

  return (
    <div className="featured-multimedia-section">
      <div className="header-container">
        <div className="header-content">
          <h3>Featured Multimedia</h3>
        </div>
      </div>
      <div className="carousel-wrapper">
        <div
          className='multimedia-container'
          ref={carouselRef}
          style={{ transform: `translateX(${translateX}px)` }}
        >
          {renderMedias()}
        </div>
        <div className='multimedia-btn-container'>
          {renderButtons()}
        </div>
      </div>
    </div>
  );
};

export default Main;